import setBannerCookieAnim from "./banner-cookies-animation.js";

function getCookie(name) {
  const escapedName = name.replace(/([.*+?^${}()|[\]\\])/g, "\\$1");
  const pattern = "(?:^|; )" + escapedName + "=([^;]*)";
  const matches = document.cookie.match(new RegExp(pattern));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

function setCookie(name, value, days) {
  let maxAge = days * 24 * 60 * 60;
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}`;
}

export function handleCookieBanner() {
  const banner = document.querySelector("#cookie-banner");
  const acceptButton = document.querySelector("#accept-cookies");
  const closeButton = document.querySelector(".cookie-banner__close");

  if (!banner || !acceptButton || !closeButton) return;

  const { showBanner, hideBanner } = setBannerCookieAnim();

  if (getCookie("cookiesAccepted")) {
    return;
  }
  showBanner();

  closeButton.addEventListener("click", () => {
    hideBanner();
  });
  acceptButton.addEventListener("click", () => {
    setCookie("cookiesAccepted", "true", 365);
    hideBanner();
  });
}
